import React from 'react';

import styles from './upgrade.scss';

const UpgradeCheckList = props => {
    return (
        <div className={`${styles.section}`}>
            <div className={`${styles.titleSection}`}>
                <div className={`${styles.title}`}>{props.title}</div>
            </div>
            <div>
                <div className={`${styles.listIntro}`}>{props.intro}</div>
                <div>
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default UpgradeCheckList;
